import React from 'react';
import { useParams } from 'react-router-dom';

import {
    useReels,
    useDeleteReelStore,
} from 'bdvp-common/src/hooks/store';

import Component from '../components/ReelsPage';

const ReelsPage = () => {

    const { userId } = useParams();
    const {
        data,
        loading,
        error,
        loadingMore,
        fetchMoreData,
    } = useReels(userId);
    const { deleteReelId } = useDeleteReelStore();
    const deleteIndex = data?.getReels?.reels.findIndex(item => item.id === deleteReelId);

    return (
        <Component
            userId={userId}
            error={error}
            loading={loading}
            loadingMore={loadingMore}
            data={data}
            fetchMoreData={fetchMoreData}
            deleteReelIndex={deleteIndex}
        />
    );

};

export default ReelsPage;
